import { Module } from "vuex";
import { RootState } from "..";
import { state, State } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

const module: Module<State, RootState> = {
  state,
  actions,
  mutations,
  getters,
};

export default module;
